"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoilMoistureArea = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const typeName = 'SoilMoistureArea';
class SoilMoistureArea extends datamodel_core_1.Area {
    constructor(ob) {
        var _a, _b, _c, _d;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
        this.name = (_b = ob.name) !== null && _b !== void 0 ? _b : this.id;
        this.soilType = (_c = ob.soilType) !== null && _c !== void 0 ? _c : null;
        this.soilRisk = (_d = ob.soilRisk) !== null && _d !== void 0 ? _d : null;
        this.soilFieldCapacity = ob.soilFieldCapacity;
        this.soilStressPoint = ob.soilStressPoint;
        this.bands = ob.bands;
    }
    getUserAttributes() {
        return {
            name: {
                type: 'String',
                editable: true,
                default: false,
                label: 'Name',
                required: true,
            },
            soilType: {
                type: 'String',
                editable: true,
                label: 'Soil Type',
                name: 'Soil Type',
                // required: true,
            },
            soilRisk: {
                type: 'String',
                editable: true,
                label: 'Soil Risk',
                name: 'Soil Risk',
                // required: true,
            },
            soilFieldCapacity: {
                type: 'String',
                editable: true,
                label: 'Soil Field Capacity (%)',
                required: false,
            },
            soilStressPoint: {
                type: 'String',
                editable: true,
                label: 'Soil Stress Point (%)',
                required: false,
            },
        };
    }
}
exports.SoilMoistureArea = SoilMoistureArea;
